import { SurveyElementTypeEnum, ValidatorType, VisibilityExpression, } from "../types/forms";
import { evaluateLogicalExpression } from "./logical-expression";
import { createExpressionFunctions, } from "./expression-functions";
import { compareTwoArraysEqual, compareTwoArraysNotEqual, getElementValueKey, isOutOfRangeValidation, isValueFilled, MATRIX_SEPARATOR_CHARACTER, } from "./helpers";
export var getVisibleChoicesForElement = function (element, formValues, elementsTypeInfoByName) {
    var baseChoices = (element.choices || []);
    if (element.choicesVisibleIf) {
        var isChoicesVisible = verifyElementCondition(element.choicesVisibleIf, formValues, elementsTypeInfoByName);
        if (!isChoicesVisible) {
            return [];
        }
    }
    return baseChoices;
};
export var evaluateElementConditions = function (element, formValues, elementsTypeInfoByName, pageEnabledFallback) {
    var _a, _b;
    var visibleFallback = (_a = element.visible) !== null && _a !== void 0 ? _a : true;
    var readOnlyFallBack = !element.readOnly;
    var requiredFallBack = (_b = element.isRequired) !== null && _b !== void 0 ? _b : false;
    var isVisibleByCondition = element.visibleIf
        ? verifyElementCondition(element.visibleIf, formValues, elementsTypeInfoByName)
        : visibleFallback;
    var isVisible = isVisibleByCondition && element.hideIfChoicesEmpty
        ? getVisibleChoicesForElement(element, formValues, elementsTypeInfoByName)
            .length > 0
        : isVisibleByCondition;
    var isEnabledByCondition = element.enableIf
        ? verifyElementCondition(element.enableIf, formValues, elementsTypeInfoByName)
        : readOnlyFallBack;
    var isEnabled = pageEnabledFallback && isEnabledByCondition;
    var isRequired = element.requiredIf
        ? verifyElementCondition(element.requiredIf, formValues, elementsTypeInfoByName)
        : requiredFallBack;
    var shouldResetValue = element.resetValueIf
        ? verifyElementCondition(element.resetValueIf, formValues, elementsTypeInfoByName)
        : false;
    var shouldSetValue = element.setValueIf
        ? verifyElementCondition(element.setValueIf, formValues, elementsTypeInfoByName)
        : false;
    return { isVisible: isVisible, isEnabled: isEnabled, isRequired: isRequired, shouldResetValue: shouldResetValue, shouldSetValue: shouldSetValue };
};
export var verifyElementCondition = function (expression, formValues, elementsTypeInfoByName) {
    if (!expression) {
        return false;
    }
    return evaluateLogicalExpression(expression, function (condition) {
        return getExpressionResult(condition, formValues, elementsTypeInfoByName);
    });
};
var DYNAMIC_TEXT_PATTERN = /{([^{}]+)}/g;
export var interpolateDynamicText = function (text, formValues) {
    if (!text)
        return text;
    return text.replace(DYNAMIC_TEXT_PATTERN, function (match, expression) {
        var trimmedExpression = expression.trim();
        var value = formValues[trimmedExpression];
        if (value === undefined || value === null) {
            return "";
        }
        return Array.isArray(value) ? value.join(", ") : String(value);
    });
};
export var resolveNavigateToUrl = function (formData, formValues, elementsTypeInfoByName) {
    var conditions = formData.navigateToUrlOnCondition;
    var matchedCondition = (conditions === null || conditions === void 0 ? void 0 : conditions.length)
        ? conditions.find(function (condition) {
            return verifyElementCondition(condition.expression, formValues, elementsTypeInfoByName);
        })
        : undefined;
    var url = matchedCondition ? matchedCondition.url : formData.navigateToUrl;
    return url ? interpolateDynamicText(url, formValues) : null;
};
export var validateValidatorsPageElements = function (pageElements, formValues, elementsTypeInfoByName) {
    var results = [];
    var _loop_1 = function (element) {
        if (!element.validators) {
            return "continue";
        }
        var valueKey = getElementValueKey(element);
        var validators = element.validators;
        var _loop_2 = function (validator) {
            var rawValue = formValues[valueKey];
            if (!isValueFilled(rawValue) &&
                validator.type !== ValidatorType.EXPRESSION) {
                return "continue";
            }
            var addError = function (defaultText) {
                results.push({
                    isValid: false,
                    errorElement: valueKey,
                    errorText: validator.text || defaultText,
                });
            };
            if (validator.type === ValidatorType.EXPRESSION) {
                var result = verifyElementCondition(validator.expression, formValues, elementsTypeInfoByName);
                if (!result) {
                    addError(validator.text || "Condição não atendida");
                    return "continue";
                }
            }
            if (validator.type === ValidatorType.NUMERIC) {
                var numValue = typeof rawValue === "string"
                    ? Number(rawValue.split(".").join("").replace(",", "."))
                    : Number(rawValue);
                if (isNaN(numValue)) {
                    addError("O valor inserido deve ser um número");
                    return "continue";
                }
                var _b = isOutOfRangeValidation(numValue, validator.minValue, validator.maxValue), isInvalid = _b.isInvalid, safeMin = _b.safeMin, safeMax = _b.safeMax, hasMin = _b.hasMin, hasMax = _b.hasMax;
                if (isInvalid) {
                    var msg = "";
                    if (hasMin && hasMax) {
                        msg =
                            safeMin === safeMax
                                ? "O valor deve ser exatamente ".concat(safeMin, ".")
                                : "O valor deve estar entre ".concat(safeMin, " e ").concat(safeMax, ".");
                    }
                    else if (hasMin) {
                        msg = "O valor num\u00E9rico deve ser no m\u00EDnimo ".concat(safeMin, ".");
                    }
                    else if (hasMax) {
                        msg = "O valor num\u00E9rico deve ser no m\u00E1ximo ".concat(safeMax, ".");
                    }
                    addError(validator.text || msg);
                    return "continue";
                }
            }
            if (validator.type === ValidatorType.TEXT) {
                var _c = isOutOfRangeValidation(rawValue.length, validator.minLength, validator.maxLength), isInvalid = _c.isInvalid, safeMin = _c.safeMin, safeMax = _c.safeMax, hasMin = _c.hasMin, hasMax = _c.hasMax;
                if (isInvalid) {
                    var msg = "";
                    if (hasMin && hasMax) {
                        msg =
                            safeMin === safeMax
                                ? "O texto deve conter exatamente ".concat(safeMin, " ").concat(safeMin === 1 ? "caractere" : "caracteres", ".")
                                : "O texto deve conter entre ".concat(safeMin, " e ").concat(safeMax, " caracteres.");
                    }
                    else if (hasMin) {
                        msg = "O texto deve conter no m\u00EDnimo ".concat(safeMin, " ").concat(safeMin === 1 ? "caractere" : "caracteres", ".");
                    }
                    else if (hasMax) {
                        msg = "O texto deve conter no m\u00E1ximo ".concat(safeMax, " ").concat(safeMax === 1 ? "caractere" : "caracteres", ".");
                    }
                    addError(msg);
                    return "continue";
                }
                if (validator.allowDigits === false) {
                    if (/\d/.test(rawValue)) {
                        addError("Não são permitidos números neste campo");
                        return "continue";
                    }
                }
            }
            if (validator.type === ValidatorType.REGEX && validator.regex) {
                var flags = validator.caseInsensitive ? "i" : "";
                if (!new RegExp(validator.regex, flags).test(rawValue)) {
                    addError("O formato do valor inserido é inválido");
                    return "continue";
                }
            }
            if (validator.type === ValidatorType.EMAIL) {
                var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(rawValue)) {
                    addError("Por favor, insira um e-mail válido");
                    return "continue";
                }
            }
            if (validator.type === ValidatorType.ANSWER_COUNT) {
                var count = Array.isArray(rawValue) ? rawValue.length : 1;
                var _d = isOutOfRangeValidation(count, validator.minCount, validator.maxCount), isInvalid = _d.isInvalid, safeMin = _d.safeMin, safeMax = _d.safeMax, hasMin = _d.hasMin, hasMax = _d.hasMax;
                if (isInvalid) {
                    var msg = "";
                    if (hasMin && hasMax) {
                        msg =
                            safeMin === safeMax
                                ? "Selecione exatamente ".concat(safeMin, " ").concat(safeMin === 1 ? "opção" : "opções", ".")
                                : "Selecione entre ".concat(safeMin, " e ").concat(safeMax, " op\u00E7\u00F5es.");
                    }
                    else if (hasMin) {
                        msg = "Selecione pelo menos ".concat(safeMin, " ").concat(safeMin === 1 ? "opção" : "opções", ".");
                    }
                    else if (hasMax) {
                        msg = "Selecione no m\u00E1ximo ".concat(safeMax, " ").concat(safeMax === 1 ? "opção" : "opções", ".");
                    }
                    addError(validator.text || msg);
                    return "continue";
                }
            }
        };
        for (var _a = 0, validators_1 = validators; _a < validators_1.length; _a++) {
            var validator = validators_1[_a];
            _loop_2(validator);
        }
    };
    for (var _i = 0, pageElements_1 = pageElements; _i < pageElements_1.length; _i++) {
        var element = pageElements_1[_i];
        _loop_1(element);
    }
    return results;
};
var getExpressionResult = function (expression, formValues, elementsTypeInfoByName) {
    if (expression.includes(VisibilityExpression.GREATER_THAN_OR_EQUAL)) {
        var _a = handleSplitExpression(expression, " ".concat(VisibilityExpression.GREATER_THAN_OR_EQUAL, " "), formValues), left = _a.left, right = _a.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        return (looseEquals(respectiveValue, right) ||
            compareGreater(respectiveValue, right));
    }
    if (expression.includes(VisibilityExpression.LESS_THAN_OR_EQUAL)) {
        var _b = handleSplitExpression(expression, " ".concat(VisibilityExpression.LESS_THAN_OR_EQUAL, " "), formValues), left = _b.left, right = _b.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        return (looseEquals(respectiveValue, right) || compareLess(respectiveValue, right));
    }
    var hasStrictEqual = includesOutsideQuotes(expression, " ".concat(VisibilityExpression.EQUAL_STRICT, " "));
    var hasStrictNotEqual = includesOutsideQuotes(expression, " ".concat(VisibilityExpression.NOT_EQUAL_STRICT, " "));
    if (hasStrictEqual || hasStrictNotEqual) {
        var from = hasStrictNotEqual
            ? VisibilityExpression.NOT_EQUAL_STRICT
            : VisibilityExpression.EQUAL_STRICT;
        var to = hasStrictNotEqual
            ? VisibilityExpression.NOT_EQUAL
            : VisibilityExpression.EQUAL;
        return getExpressionResult(replaceOutsideQuotes(expression, " ".concat(from, " "), " ".concat(to, " ")), formValues, elementsTypeInfoByName);
    }
    if (expression.includes(VisibilityExpression.EQUAL)) {
        var _c = handleSplitExpression(expression, " ".concat(VisibilityExpression.EQUAL, " "), formValues), left = _c.left, right = _c.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        var itemTypeInfo = elementsTypeInfoByName[left];
        if ((itemTypeInfo === null || itemTypeInfo === void 0 ? void 0 : itemTypeInfo.type) === SurveyElementTypeEnum.BOOLEAN) {
            return respectiveValue === right;
        }
        if (respectiveValue === undefined || respectiveValue === null) {
            return false;
        }
        if ((itemTypeInfo === null || itemTypeInfo === void 0 ? void 0 : itemTypeInfo.type) === SurveyElementTypeEnum.RANKING) {
            return compareTwoArraysEqual({
                array1: respectiveValue,
                array2: toComparableArray(right),
                orderMatter: true,
            });
        }
        if (Array.isArray(respectiveValue)) {
            return compareTwoArraysEqual({
                array1: respectiveValue,
                array2: toComparableArray(right),
            });
        }
        // eslint-disable-next-line eqeqeq
        return respectiveValue == right;
    }
    if (expression.includes(VisibilityExpression.NOT_EQUAL)) {
        var _d = handleSplitExpression(expression, " ".concat(VisibilityExpression.NOT_EQUAL, " "), formValues), left = _d.left, right = _d.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        var itemTypeInfo = elementsTypeInfoByName[left];
        if ((itemTypeInfo === null || itemTypeInfo === void 0 ? void 0 : itemTypeInfo.type) === SurveyElementTypeEnum.BOOLEAN) {
            return respectiveValue !== right;
        }
        if (respectiveValue === undefined || respectiveValue === null) {
            return true;
        }
        if ((itemTypeInfo === null || itemTypeInfo === void 0 ? void 0 : itemTypeInfo.type) === SurveyElementTypeEnum.RANKING) {
            return compareTwoArraysNotEqual({
                array1: respectiveValue,
                array2: toComparableArray(right),
                orderMatter: true,
            });
        }
        if (Array.isArray(respectiveValue)) {
            return compareTwoArraysNotEqual({
                array1: respectiveValue,
                array2: toComparableArray(right),
            });
        }
        // eslint-disable-next-line eqeqeq
        return respectiveValue != right;
    }
    if (expression.includes(VisibilityExpression.GREATER_THAN)) {
        var _e = handleSplitExpression(expression, " ".concat(VisibilityExpression.GREATER_THAN, " "), formValues), left = _e.left, right = _e.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        return compareGreater(respectiveValue, right);
    }
    if (expression.includes(VisibilityExpression.LESS_THAN)) {
        var _f = handleSplitExpression(expression, " ".concat(VisibilityExpression.LESS_THAN, " "), formValues), left = _f.left, right = _f.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        return compareLess(respectiveValue, right);
    }
    if (expression.includes(VisibilityExpression.NOT_EMPTY)) {
        var left = handleSplitExpression(expression, " ".concat(VisibilityExpression.NOT_EMPTY), formValues).left;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        var isEmpty = respectiveValue === null ||
            respectiveValue === undefined ||
            respectiveValue === "" ||
            (typeof respectiveValue === "object" &&
                Object.keys(respectiveValue).length === 0);
        return !isEmpty;
    }
    if (expression.includes(VisibilityExpression.EMPTY)) {
        var left = handleSplitExpression(expression, " ".concat(VisibilityExpression.EMPTY), formValues).left;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        var isEmpty = respectiveValue === false ||
            respectiveValue === null ||
            respectiveValue === undefined ||
            respectiveValue === "" ||
            (typeof respectiveValue === "object" &&
                Object.keys(respectiveValue).length === 0);
        return isEmpty;
    }
    if (expression.includes(VisibilityExpression.NOT_CONTAINS)) {
        var _g = handleSplitExpression(expression, " ".concat(VisibilityExpression.NOT_CONTAINS, " "), formValues), left = _g.left, right = _g.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        if (respectiveValue === undefined || respectiveValue === null) {
            return true;
        }
        if (isNullish(right)) {
            return true;
        }
        return !respectiveValue.toString().includes(right.toString());
    }
    if (expression.includes(VisibilityExpression.CONTAINS)) {
        var _h = handleSplitExpression(expression, " ".concat(VisibilityExpression.CONTAINS, " "), formValues), left = _h.left, right = _h.right;
        var respectiveValue = handleGetRespectiveValue(left, formValues);
        if (respectiveValue === undefined || respectiveValue === null) {
            return false;
        }
        if (isNullish(right)) {
            return false;
        }
        return respectiveValue.toString().includes(right.toString());
    }
    if (expression.includes(VisibilityExpression.ANY_OF)) {
        var _j = handleSplitExpression(expression, " ".concat(VisibilityExpression.ANY_OF, " "), formValues), left = _j.left, right = _j.right;
        var respectiveValue_1 = handleGetRespectiveValue(left, formValues);
        if (respectiveValue_1 === undefined || respectiveValue_1 === null) {
            return false;
        }
        var rightValues_1 = toComparableArray(right).filter(function (item) { return !isNullish(item); });
        if (Array.isArray(respectiveValue_1)) {
            return respectiveValue_1.some(function (value) {
                return rightValues_1.map(function (item) { return item.toString(); }).includes(value);
            });
        }
        return rightValues_1.some(function (item) { return item.toString() === (respectiveValue_1 === null || respectiveValue_1 === void 0 ? void 0 : respectiveValue_1.toString()); });
    }
    if (expression.includes(VisibilityExpression.ALL_OF)) {
        var _k = handleSplitExpression(expression, " ".concat(VisibilityExpression.ALL_OF, " "), formValues), left = _k.left, right = _k.right;
        var respectiveValue_2 = handleGetRespectiveValue(left, formValues);
        if (respectiveValue_2 === undefined || respectiveValue_2 === null) {
            return false;
        }
        return toComparableArray(right)
            .filter(function (item) { return !isNullish(item); })
            .every(function (value) { return respectiveValue_2.includes(value.toString()); });
    }
    return false;
};
var handleSplitExpression = function (expression, separator, formValues) {
    var _a = expression.split(separator), left = _a[0], right = _a[1];
    var formattedLeft = handleFormatLeftValue(left);
    var formattedRight = handleFormatRightValue(right, formValues);
    return {
        left: formattedLeft,
        right: formattedRight,
    };
};
/**
 * Remove ocorrências do caractere que estejam fora de aspas. O Creator adiciona
 * parênteses ao redor da condição quando ela vem de uma coluna de matrix, e o
 * parser já consome os de agrupamento, sobra a limpeza defensiva. Fazer isso
 * respeitando aspas evita destruir literais como `'texto (com parênteses)'`.
 */
var removeUnquotedCharacter = function (value, character) {
    var result = "";
    var quote = null;
    for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
        var char = value_1[_i];
        if (quote) {
            if (char === quote) {
                quote = null;
            }
            result += char;
            continue;
        }
        if (char === "'" || char === '"') {
            quote = char;
            result += char;
            continue;
        }
        if (char !== character) {
            result += char;
        }
    }
    return result;
};
/**
 * Troca `search` por `replacement` apenas fora de aspas. Sem isso, normalizar
 * `==` para `=` estragaria um literal como `'x == y'`.
 */
var replaceOutsideQuotes = function (value, search, replacement) {
    var result = "";
    var quote = null;
    var i = 0;
    while (i < value.length) {
        var char = value[i];
        if (quote) {
            if (char === quote) {
                quote = null;
            }
            result += char;
            i++;
            continue;
        }
        if (char === "'" || char === '"') {
            quote = char;
            result += char;
            i++;
            continue;
        }
        if (value.startsWith(search, i)) {
            result += replacement;
            i += search.length;
            continue;
        }
        result += char;
        i++;
    }
    return result;
};
var includesOutsideQuotes = function (value, search) {
    return replaceOutsideQuotes(value, search, "\u0000") !== value;
};
var handleFormatLeftValue = function (value) {
    var trimmed = value.trim();
    if (isFunctionCall(trimmed)) {
        return trimmed;
    }
    return removeUnquotedCharacter(trimmed.replace("{", "").replace("}", ""), "(");
};
var FIELD_REFERENCE_PATTERN = /^\{[^{}]+\}$/;
var handleFormatRightValue = function (value, formValues) {
    if (value === undefined) {
        return "";
    }
    if (isFunctionCall(value)) {
        return evaluateValueExpression(value.trim(), formValues);
    }
    value = removeUnquotedCharacter(value.trim(), ")");
    // `{campo} <= {outroCampo}`: sem isto o lado direito seria comparado como o
    // texto literal "{outroCampo}".
    if (FIELD_REFERENCE_PATTERN.test(value)) {
        return handleGetRespectiveValue(value.slice(1, -1).trim(), formValues);
    }
    if (value.startsWith("[") && value.endsWith("]")) {
        try {
            var validJson = value.replace(/'/g, '"');
            return JSON.parse(validJson);
        }
        catch (e) {
            return value;
        }
    }
    if (value !== "" && !isNaN(Number(value))) {
        return Number(value);
    }
    if (value === "true" || value === "false") {
        return value === "true" ? true : false;
    }
    return value.replace(/['"]/g, "");
};
var isNullish = function (value) {
    return value === undefined || value === null;
};
var looseEquals = function (left, right) {
    if (isNullish(left) && isNullish(right)) {
        return true;
    }
    if (isNullish(left)) {
        return right === "";
    }
    if (isNullish(right)) {
        return left === "";
    }
    // eslint-disable-next-line eqeqeq
    return left == right;
};
var compareGreater = function (left, right) {
    return isNullish(left) || isNullish(right) ? false : left > right;
};
var compareLess = function (left, right) {
    return isNullish(left) || isNullish(right) ? false : left < right;
};
var toComparableArray = function (value) {
    return Array.isArray(value) ? value : [value];
};
export var handleGetRespectiveValue = function (left, formValues) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (isFunctionCall(left)) {
        return evaluateValueExpression(left, formValues);
    }
    // Ex: {pergunta1[0].Column 1} = 2
    var matrixDynamicMatch = /^(.+)\[(\d+)\]\.(.+)$/.exec(left);
    if (matrixDynamicMatch) {
        var fieldName = matrixDynamicMatch[1], indexStr = matrixDynamicMatch[2], columnName = matrixDynamicMatch[3];
        var index = Number.parseInt(indexStr, 10);
        return (_c = (_b = (_a = formValues === null || formValues === void 0 ? void 0 : formValues[fieldName]) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b[columnName]) !== null && _c !== void 0 ? _c : null;
    }
    // Ex: {pergunta1.Row 1.Column 1} = 2
    if (left.includes(MATRIX_SEPARATOR_CHARACTER)) {
        var parts = left.split(MATRIX_SEPARATOR_CHARACTER);
        if (parts.length === 3) {
            var fieldName = parts[0], rowKey = parts[1], columnKey = parts[2];
            return (_f = (_e = (_d = formValues === null || formValues === void 0 ? void 0 : formValues[fieldName]) === null || _d === void 0 ? void 0 : _d[rowKey]) === null || _e === void 0 ? void 0 : _e[columnKey]) !== null && _f !== void 0 ? _f : null;
        }
        // Ex: {pergunta1.Row 1} = 'Column 1'
        var row = parts[0], column = parts[1];
        return (_h = (_g = formValues === null || formValues === void 0 ? void 0 : formValues[row]) === null || _g === void 0 ? void 0 : _g[column]) !== null && _h !== void 0 ? _h : null;
    }
    return formValues[left];
};
var VALUE_EXPRESSION_FUNCTIONS = createExpressionFunctions({
    evaluateCondition: function (expression, values) {
        return verifyElementCondition(expression, values, {});
    },
});
var FUNCTION_NAMES = Object.keys(VALUE_EXPRESSION_FUNCTIONS);
/**
 * Reconhece `nome(` no começo do operando, e só para nome registrado — assim
 * `{campo}` e literais seguem pelo caminho de sempre.
 */
var isFunctionCall = function (value) {
    var trimmed = value.trim();
    return FUNCTION_NAMES.some(function (name) {
        return trimmed.startsWith(name) && /^\s*\(/.test(trimmed.slice(name.length));
    });
};
var tokenizeValueExpression = function (expression) {
    var _a;
    var tokens = [];
    var len = expression.length;
    var i = 0;
    while (i < len) {
        var char = expression[i];
        if (/\s/.test(char)) {
            i++;
            continue;
        }
        if (char === "{") {
            var end = expression.indexOf("}", i);
            if (end === -1) {
                break;
            }
            tokens.push({
                type: "field",
                value: expression.slice(i + 1, end).trim(),
            });
            i = end + 1;
            continue;
        }
        if (char === "'" || char === '"') {
            var quote = char;
            var j = i + 1;
            var str = "";
            while (j < len && expression[j] !== quote) {
                str += expression[j];
                j++;
            }
            tokens.push({ type: "str", value: str });
            i = j + 1;
            continue;
        }
        if (/[0-9]/.test(char) ||
            (char === "." && /[0-9]/.test((_a = expression[i + 1]) !== null && _a !== void 0 ? _a : ""))) {
            var j = i;
            while (j < len && /[0-9.]/.test(expression[j])) {
                j++;
            }
            tokens.push({ type: "num", value: expression.slice(i, j) });
            i = j;
            continue;
        }
        if (char === "(" || char === ")") {
            tokens.push({ type: char === "(" ? "lparen" : "rparen", value: char });
            i++;
            continue;
        }
        if (char === ",") {
            tokens.push({ type: "comma", value: char });
            i++;
            continue;
        }
        if (/[A-Za-z_]/.test(char)) {
            var j = i;
            while (j < len && /[A-Za-z0-9_]/.test(expression[j])) {
                j++;
            }
            var name = expression.slice(i, j);
            var k = j;
            while (k < len && /\s/.test(expression[k])) {
                k++;
            }
            if (expression[k] === "(" && VALUE_EXPRESSION_FUNCTIONS[name]) {
                tokens.push({ type: "func", value: name });
                i = k;
                continue;
            }
            i = j;
            continue;
        }
        var twoChars = expression.slice(i, i + 2);
        if ([">=", "<=", "<>", "!=", "=="].includes(twoChars)) {
            tokens.push({ type: "cmp", value: twoChars });
            i += 2;
            continue;
        }
        if (char === ">" || char === "<" || char === "=") {
            tokens.push({ type: "cmp", value: char });
            i++;
            continue;
        }
        if (char === "+" || char === "-" || char === "*" || char === "/") {
            tokens.push({ type: "op", value: char });
            i++;
            continue;
        }
        i++;
    }
    return tokens;
};
var isValueEmptyForArithmetic = function (value) {
    if (Array.isArray(value) && value.length === 0) {
        return true;
    }
    return !value && value !== 0 && value !== false;
};
var convertForArithmeticOp = function (value, second) {
    if (!isValueEmptyForArithmetic(value)) {
        return value;
    }
    if (typeof second === "number") {
        return 0;
    }
    if (typeof value === "string") {
        return value;
    }
    if (typeof second === "string") {
        return "";
    }
    if (Array.isArray(second)) {
        return [];
    }
    return 0;
};
export var evaluateValueExpression = function (expression, formValues) {
    var tokens = tokenizeValueExpression(expression);
    var pos = 0;
    var peek = function () { return tokens[pos]; };
    var consume = function () { return tokens[pos++]; };
    var parseExpression = function () {
        var _a;
        var parseFactor = function () {
            var _a, _b, _c;
            var token = peek();
            if (!token) {
                return null;
            }
            if (token.type === "op" && token.value === "-") {
                consume();
                var value_2 = parseFactor();
                return -(Number(value_2) || 0);
            }
            if (token.type === "lparen") {
                consume();
                var value_3 = parseExpression();
                if (((_a = peek()) === null || _a === void 0 ? void 0 : _a.type) === "rparen") {
                    consume();
                }
                return value_3;
            }
            if (token.type === "num") {
                consume();
                return Number(token.value);
            }
            if (token.type === "str") {
                consume();
                return token.value;
            }
            if (token.type === "field") {
                consume();
                var value_4 = handleGetRespectiveValue(token.value, formValues);
                return value_4 === undefined ? null : value_4;
            }
            if (token.type === "func") {
                consume();
                var args = [];
                if (((_b = peek()) === null || _b === void 0 ? void 0 : _b.type) === "lparen") {
                    consume();
                    while (peek() && peek().type !== "rparen") {
                        if (peek().type === "comma") {
                            consume();
                            continue;
                        }
                        args.push(parseExpression());
                    }
                    if (((_c = peek()) === null || _c === void 0 ? void 0 : _c.type) === "rparen") {
                        consume();
                    }
                }
                return VALUE_EXPRESSION_FUNCTIONS[token.value](args);
            }
            consume();
            return null;
        };
        var parseTerm = function () {
            var _a;
            var value = parseFactor();
            while (((_a = peek()) === null || _a === void 0 ? void 0 : _a.type) === "op" &&
                (peek().value === "*" || peek().value === "/")) {
                var op = consume().value;
                var right = parseFactor();
                var left = convertForArithmeticOp(value, right);
                var rightOperand = convertForArithmeticOp(right, left);
                if (op === "/") {
                    value = !Number(rightOperand)
                        ? null
                        : Number(left) / Number(rightOperand);
                }
                else {
                    value = (Number(left) || 0) * (Number(rightOperand) || 0);
                }
            }
            return value;
        };
        var parseAdditive = function () {
            var _a;
            var value = parseTerm();
            while (((_a = peek()) === null || _a === void 0 ? void 0 : _a.type) === "op" &&
                (peek().value === "+" || peek().value === "-")) {
                var op = consume().value;
                var right = parseTerm();
                var left = convertForArithmeticOp(value, right);
                var rightOperand = convertForArithmeticOp(right, left);
                if (op === "+") {
                    if (typeof left === "string" || typeof rightOperand === "string") {
                        value = "".concat(left).concat(rightOperand);
                    }
                    else {
                        value = (Number(left) || 0) + (Number(rightOperand) || 0);
                    }
                }
                else {
                    value = (Number(left) || 0) - (Number(rightOperand) || 0);
                }
            }
            return value;
        };
        // Comparação é o nível mais externo, como na gramática do SurveyJS, é o
        // que faz `iif({idade} > 18, 'a', 'b')` funcionar.
        var value = parseAdditive();
        while (((_a = peek()) === null || _a === void 0 ? void 0 : _a.type) === "cmp") {
            var operator = consume().value;
            var right = parseAdditive();
            switch (operator) {
                case ">":
                    value = compareGreater(value, right);
                    break;
                case "<":
                    value = compareLess(value, right);
                    break;
                case ">=":
                    value = looseEquals(value, right) || compareGreater(value, right);
                    break;
                case "<=":
                    value = looseEquals(value, right) || compareLess(value, right);
                    break;
                case "<>":
                case "!=":
                    value = !looseEquals(value, right);
                    break;
                default:
                    value = looseEquals(value, right);
            }
        }
        return value;
    };
    return parseExpression();
};
